/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type MerchantNames_storeLists$ref: FragmentReference;
declare export opaque type MerchantNames_storeLists$fragmentType: MerchantNames_storeLists$ref;
export type MerchantNames_storeLists = {|
  +id: string,
  +merchantNames: $ReadOnlyArray<{|
    +id: string,
    +name: string,
  |}>,
  +$refType: MerchantNames_storeLists$ref,
|};
export type MerchantNames_storeLists$data = MerchantNames_storeLists;
export type MerchantNames_storeLists$key = {
  +$data?: MerchantNames_storeLists$data,
  +$fragmentRefs: MerchantNames_storeLists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "storeId",
      "type": "ID!"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MerchantNames_storeLists",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "storeId",
          "variableName": "storeId"
        }
      ],
      "concreteType": "MerchantName",
      "kind": "LinkedField",
      "name": "merchantNames",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoreLists"
};
})();
// prettier-ignore
(node/*: any*/).hash = '818e1ee360eb80759e0586b5e87b4843';

module.exports = node;
